import { render } from "./BrandLogo.vue?vue&type=template&id=339c5cdc"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__